module.exports = __webpack_public_path__ + "static/media/jinx-win.e8a4d834.png";